import { render, staticRenderFns } from "./integralGiftConvert.vue?vue&type=template&id=16ca2d82&scoped=true&"
import script from "./integralGiftConvert.vue?vue&type=script&lang=js&"
export * from "./integralGiftConvert.vue?vue&type=script&lang=js&"
import style0 from "./integralGiftConvert.vue?vue&type=style&index=0&id=16ca2d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca2d82",
  null
  
)

export default component.exports